import type { NavigateFunction } from 'react-router-dom';

import type { VideoRoomNavigationPort } from '@zingizi/video-room';

export function createZingiziNavigationPort(navigate: NavigateFunction): VideoRoomNavigationPort {
  return {
    goToSessionEnd(roomName: string) {
      navigate(`/end-call/${roomName}`);
    },
    goToPath(path: string) {
      navigate(path);
    },
  };
}
